<template>
	<mu-row>
		<mu-col class="col-12">
			<p>
				<strong>{{ contact_title }}</strong>
				<br />
				{{contact_description}}
				<a
					href="callcenter@vallartaplus.com"
					style="color: #dfc454 !important"
				>callcenter@vallartaplus.com</a>
			</p>
			<mu-row class="text-center text-primary">
				<mu-col class="col-12 col-xl-3 col-lg-4 col-md-4 col-sm-6">
					<strong>Tel.</strong> (33) 3-111-8778
				</mu-col>
				<mu-col class="col-12 col-xl-3 col-lg-4 col-md-4 col-sm-6">
					<strong>Tel.</strong> (33) 3-111-8770
				</mu-col>
				<mu-col class="col-12 col-xl-3 col-lg-4 col-md-4 col-sm-6">
					<strong>Tel.</strong> (33) 3-111-8771
				</mu-col>
				<mu-col class="col-12 col-xl-3 col-lg-4 col-md-4 col-sm-6">01 800 0000 909</mu-col>
				<mu-col class="col-12 col-xl-3 col-lg-4 col-md-4 col-sm-6 text-success">
					<strong>Whatsapp</strong> 331 526 6794
				</mu-col>
			</mu-row>
		</mu-col>
	</mu-row>
</template>

<script>
export default {
	name: "contact_phone",
	props: ["contact_title", "contact_description"],
};
</script>

<style>
</style>